import { Component, OnInit } from '@angular/core';
import { environment } from 'apps/learn-my-way/src/environments/environment';

@Component({
  selector: 'lmw-base-breadcrumb-and-navigation',
  templateUrl: './breadcrumb-and-navigation.component.html'
})
export class BreadcrumbAndNavigationComponent implements OnInit {

  public language: string = environment.language;

  constructor() {}

  ngOnInit() {}
}